import React, { useState } from 'react';
import { Alert, Modal } from 'antd';
import { modalNames } from '../../../shared/configs/modal';
import {
  useModalWatch,
  useModalMethods,
} from '../../../shared/packages/modalManager';
import { useFormController } from '../../../../../helpers/formManager';
import { useDeskNamesQuery, useSetDeskNameMutation } from '../../../api/desk';
import { fieldNames } from '../constants';
import CheckDeskBusy from './CheckDeskBusy';
import NameField from './NameField';

const modalName = modalNames.setDeskName;
const nameField = fieldNames.deskName;

const ModalForm = () => {
  const { isOpen, props } = useModalWatch({ name: modalName });
  const { id: deskId, serviceCompanyId } = props || {};

  const { isFetching } = useDeskNamesQuery({ params: { serviceCompanyId } });

  const { close } = useModalMethods();

  const { control, handleSubmit, reset, setError } = useFormController({
    mode: 'onChange',
    shouldUnregister: true,
  });

  const [isChecking, setIsChecking] = useState(false);
  const [responseError, setResponseError] = useState();

  const handleCancel = () => close(modalName);

  const handleSetDeskNameSuccess = ({ success, message }) =>
    success ? handleCancel() : setResponseError(message);

  const { mutate: deskNameMutate, isLoading: isSetDeskNameLoading } =
    useSetDeskNameMutation({ onSuccess: handleSetDeskNameSuccess });

  const onSubmit = (data) => {
    const isEdit = Boolean(deskId);

    const payload = { isEdit, deskName: data[nameField].trim() };

    isEdit
      ? (payload.deskId = deskId)
      : (payload.serviceCompanyId = serviceCompanyId);

    deskNameMutate(payload);
  };

  const resetResponseError = () => setResponseError();

  const handleAfterClose = () => {
    reset();
    setIsChecking(false);
    resetResponseError();
  };

  return (
    <Modal
      title={deskId ? 'Изменить название стола' : 'Создать новый стол'}
      visible={isOpen}
      onCancel={handleCancel}
      onOk={handleSubmit(onSubmit)}
      centered
      width={620}
      maskClosable={false}
      destroyOnClose
      okButtonProps={{ disabled: isFetching || isChecking }}
      okText={deskId ? 'Изменить' : 'Создать'}
      afterClose={handleAfterClose}
      confirmLoading={isSetDeskNameLoading}
    >
      <CheckDeskBusy loading={isFetching}>
        <form>
          <NameField
            control={control}
            setIsChecking={setIsChecking}
            setError={setError}
          />
        </form>
        {Boolean(responseError) && (
          <Alert
            message={responseError}
            closable
            afterClose={resetResponseError}
            style={{ marginTop: 10 }}
            type="error"
            showIcon
          />
        )}
      </CheckDeskBusy>
    </Modal>
  );
};

export default ModalForm;
